import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	fetchaddMessageThunk,
	fetchCreateTeTicketThunk,
	fetchgetTicketMessagesThunk,
	fetchticketCategoriesThunk,
	fetchticketListingThunk,
} from './ticketApi'

const initialState = {
	CreateTicketData: [],
	ticketData: [],
	totalCountofTicketData: 0,
	ticketCategoriesData: [],
	addMessageData: [],
	getTicketMessagesData: [],
}

export const getCreateTicketData = createAsyncThunk('user/getCreateTicketData', fetchCreateTeTicketThunk)
export const getticketListing = createAsyncThunk('user/getticketListing', fetchticketListingThunk)
export const getTicketCategoriesData = createAsyncThunk('user/getTicketCategoriesData', fetchticketCategoriesThunk)
export const addMessage = createAsyncThunk('user/addMessage', fetchaddMessageThunk)
export const getTicketMessages = createAsyncThunk('user/getTicketMessages', fetchgetTicketMessagesThunk)

export const ticketSlice = createSlice({
	name: 'ticket',
	initialState,

	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getCreateTicketData.fulfilled, (state, action) => {
			state.CreateTicketData = action.payload?.data
		})
		builder.addCase(getTicketCategoriesData.fulfilled, (state, action) => {
			state.ticketCategoriesData = action.payload?.data
		})
		builder.addCase(getticketListing.fulfilled, (state, action) => {
			state.ticketData = action.payload?.data
			state.totalCountofTicketData = action.payload?.total
		})
		builder.addCase(addMessage.fulfilled, (state, action) => {
			state.addMessageData = action.payload?.data
		})
		builder.addCase(getTicketMessages.fulfilled, (state, action) => {
			state.getTicketMessagesData = action.payload?.data
		})
	},
})
export default ticketSlice.reducer
